<template>
  <div class="tracking" v-if="dataPermission.includes('CNPS_TKLC_SEARCH')">
    <div class="breadcrumb-area pos-relative" style="margin-top: 8px">
      <h1>Tracking</h1>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="clickSearch">
          <div class="form-group">
            <label>Loại thống kê</label>
            <Select2 v-model="modelSelectRealTime" :options="dataSelectRealtime" />
          </div>
          <div class="form-group" v-if="modelSelectRealTime === 'OFF'">
            <label>Thời gian</label>
            <DateRangePicker
              :ranges="false"
              class="w-100"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label style="min-width: 13.5em">
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
              </template>
              <!--Optional scope for the input displaying the dates -->
            </DateRangePicker>
          </div>
          <div class="form-group">
            <label>Tỉnh/TP</label>
            <Select2
              v-model="suggestAddress"
              :options="dataProvince"
              @change="queryDistrict(suggestAddress)"
              placeholder="Tỉnh/TP"
            />
          </div>
          <div class="form-group">
            <label>Quận/Huyện</label>
            <Select2
              v-model="suggestDistrict"
              :options="dataDistrict"
              @change="selectDistrict()"
              placeholder="Quận/Huyện"
            />
          </div>
          <div class="form-group">
            <label>Bán kính</label>
            <input
              type="text"
              class="form-control f12 hc-37"
              placeholder="Bán kính"
              v-model="radius"
              @change="changeRadius"
            />
          </div>
          <div class="form-group">
            <label>Nhân viên</label>
            <Select2 v-model="search.userIds" :options="dataStaffs" placeholder="Nhân viên" />
            <!-- <multiselect style="margin-top: -2px" v-model="searchUserId" :hide-selected="true" value="id" track-by="id" label="text" :multiple="true" :options="dataStaffs" :searchable="true" :close-on-select="false" :show-labels="false" :taggable="true" limit="1" placeholder="Chọn nhân viên">
            </multiselect> -->
          </div>
          <div class="form-group">
            <label>Trạng thái Nhân viên</label>
            <Select2
              v-model="search.userStatus"
              :options="dataStatusStaff"
              @change="convertDataStaff(search.userStatus)"
              placeholder="Trạng thái nhân viên"
            />
          </div>
          <div class="form-group">
            <label>Trạng thái</label>
            <Select2
              v-model="search.appOnForeground"
              :options="dataAppOnForeground"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group">
            <label>Loại thiết bị</label>
            <Select2
              v-model="search.deviceType"
              :options="dataDeviceType"
              placeholder="Loại thiết bị"
            />
          </div>
          <div class="form-group">
            <label>Loại tracking</label>
            <Select2
              v-model="search.checkingType"
              :options="dataTrackingType"
              placeholder="Loại tracking"
            />
          </div>

          <div class="d-inline-block m-t-23">
            <button
              type="button"
              class="btn btn-primary hc-37 mr-2 m-b-10 pt-2"
              title="Lọc"
              @click="clickSearch"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 m-b-10 pt-2"
              title="Bỏ lọc"
              @click="clearSearch"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
            <button
              :disabled="disableShowMap"
              type="button"
              class="btn btn-primary hc-37 mr-2 m-b-10 pt-2 cursor-disable"
              title="Hiển thi bản đồ"
              @click="isShowMap = !isShowMap"
            >
              <i class="bx bx-map"></i><span>&nbsp;</span>
              <span v-if="isShowMap === false">Hiển thị bản đồ</span>
              <span v-else>Ẩn bản đồ</span>
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div v-if="isShowMap" class="form-row">
            <div class="col-md-12">
              <div class="box-maps">
                <GmapMap
                  @click="clickMap"
                  ref="map"
                  :center="markersCenter"
                  :zoom="14"
                  :clickable="true"
                  style="width: 100%; height: 800px"
                >
                  <GmapMarker
                    :key="index"
                    v-for="(m, index) in dataMarkerShow"
                    :position="m.position"
                    :icon="{
                      url: require(`${m.appOnForeground ? './icon/onl.png' : './icon/off.png'}`),
                      scaledSize: { width: 40, height: 60 },
                    }"
                    @click="toggleInfo(m, index)"
                    :clickable="false"
                    :draggable="false"
                  />
                  <gmap-marker :position="markersCenter"></gmap-marker>

                  <gmap-cluster v-for="(item, index) in dataPolygonByLatlng" :key="index">
                    <gmap-polygon
                      ref="polygon"
                      @click="removeShape(index)"
                      :paths="item.points"
                      :options="optionPolygom"
                    ></gmap-polygon>
                    <gmap-marker :position="markersCenter"></gmap-marker>
                  </gmap-cluster>

                  <gmap-info-window
                    :options="infoOptions"
                    :position="infoWindowPos"
                    :opened="infoWinOpen"
                    @closeclick="infoWinOpen = false"
                  >
                    <div v-html="infoContent"></div>
                  </gmap-info-window>
                  <GmapCircle
                    @center_changed="centerChanged"
                    :center="markersCenter"
                    :radius="radiusMap"
                    :visible="true"
                    :options="{
                      strokeOpacity: 0.6,
                      fillOpacity: 0.2,
                      strokeColor: '#74ae49',
                    }"
                  ></GmapCircle>
                </GmapMap>
              </div>
            </div>
          </div>

          <div class="table-responsive mt-4 font-size-16">
            <div class="box-header">
              Tổng số :<strong class="text-primary">{{ totalTracking || 0 }}</strong> &nbsp;&nbsp;|
              &nbsp;&nbsp; Hoạt động :<strong class="text-primary">0</strong> &nbsp;&nbsp;|
              &nbsp;&nbsp; Đã khóa :<strong class="text-primary">0</strong>
            </div>
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-center">STT</th>
                  <th scope="col">Tên</th>
                  <th scope="col">Thời gian tracking</th>
                  <th scope="col">Email</th>
                  <th scope="col">Số điện thoại</th>
                  <th scope="col">Thiết bị</th>
                  <th scope="col">Loại tracking</th>
                  <th scope="col">Trạng thái</th>
                  <th scope="col" width="15%">Địa chỉ</th>
                  <th scope="col">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="(item, index) in dataItems" :key="index">
                  <td class="text-center" style="width: 50px">
                    {{ pagination.size * (pagination.page - 1) + index + 1 }}
                  </td>
                  <td>
                    <b>{{ item.name }}</b> <br />
                  </td>
                  <td>{{ item.lastUpdated | formatDate('DD/MM/YYYY HH:mm:ss') }}</td>
                  <td>{{ item.userName }}</td>
                  <td>{{ item.mobile }}</td>
                  <td>
                    {{ item.deviceType === 'android' ? 'ANDROID' : 'IOS' }}
                  </td>
                  <td>
                    {{ item.checkingType | transformData(dataTrackingType) }}
                  </td>
                  <td>
                    <span
                      class="badge"
                      v-bind:class="[item.appOnForeground ? 'SENT' : 'SIGNED_MISS_IMAGE']"
                      >{{ item.appOnForeground ? 'TRỰC TUYẾN' : 'NGOẠI TUYẾN' }}</span
                    >
                  </td>
                  <td>{{ item.address ? item.address : '' }}</td>
                  <td align="center">
                    <b-dropdown class="text-center" variant="outline-light">
                      <router-link
                        class="dropdown-item"
                        :to="`tracking/detail/?id=${item.userId}`"
                        target="_blank"
                        ><i class="bx bx-show-alt"></i> Chi tiết</router-link
                      >
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination-bottom">
            <b-pagination
              v-model="pagination.page"
              :total-rows="pagination.totalRows"
              :per-page="pagination.size"
              @input="paginationChange"
              class="fl-right mr-2"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '../../thirdParty/config'
  import { TrackingService } from '@/services/tracking.service'
  import { StaffService } from '@/services/staff.service'
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  export default {
    data: () => {
      return {
        isShowMap: false,
        msg: 'Tracking',
        loading: false,
        dataItems: [],
        dataListManage: [],
        dataStaffs: [],
        dataAllStaffs: [],
        dataProvince: [],
        dataDistrict: [],
        search: {},
        searchUserId: '',
        pagination: {
          page: 1,
          totalRows: 0,
          size: 20,
        },
        addressChanged: {},

        dataList: [],

        searchStaff: {
          superior: '',
          size: 5000,
          page: 1,
        },
        suggestAddress: null,
        suggestDistrict: null,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataSelectRealtime: [
          {
            id: 'ON',
            text: 'Real time',
          },
          {
            id: 'OFF',
            text: 'Theo ngày',
          },
        ],
        modelSelectRealTime: 'ON',
        dataAppOnForeground: [
          {
            id: 'all',
            text: 'Tất cả',
          },
          {
            id: true,
            text: 'Trực tuyến',
          },
          {
            id: false,
            text: 'Ngoại tuyến',
          },
        ],
        dataStatusStaff: Config.dataStatusStaff,
        localeData: Config.localeData,

        dateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },

        dataDeviceType: [
          {
            id: 'all',
            text: 'Tất cả',
          },
          {
            id: 'ios',
            text: 'IOS',
          },
          {
            id: 'android',
            text: 'Android',
          },
        ],

        markersCenter: {
          lat: Config.positionNexttech.lat,
          lng: Config.positionNexttech.lng,
        },

        markerNow: {},
        markers: [],
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0,
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
        radius: 2,
        radiusMap: 2000,
        dataPolygonByLatlng: [],
        locationCenterSearch: null,
        totalTracking: null,
        dataMarkerShow: [],
        dataTrackingType: [{ id: 'all', text: 'Tất cả' }, ...Config.trackingType],
        isShowMap: false,
        disableShowMap: true,
      }
    },

    components: {},

    async created() {
      // this.getSuperiors()
      this.getStaff()
      this.search.userStatus = 'ACTIVE'
      this.convertDataStaff('ACTIVE')
      this.suggestLocation()
      this.locationCenterSearch = this.markersCenter
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      async locationSearch() {
        try {
          this.loading = true

          this.centerChanged()

          const dataMarkers = []
          if (typeof this.search.userIds === 'string') {
            // search userId
            this.search.userIds = [this.search.userIds]
          }
          const response = await TrackingService.locationSearch(this.search)
          this.dataItems = []
          if (response.success === false) {
            this.showFailMx(response.message)
            return
          }
          if (response.data.length > 0) {
            this.pagination.totalRows = response.data.length
            this.dataList = response.data
            this.totalTracking = response.data.length
            if (this.totalTracking >= 2000) this.isShowMap = false
            else this.disableShowMap = false
            response.data.map(async (item, index) => {
              const body = {
                userId: item.userId,
                name: item.name,
                mobile: item.mobile,
                email: item.userName,
                lastUpdated: item.lastUpdated,
                position: {
                  lat: parseFloat(item.latitude),
                  lng: parseFloat(item.longitude),
                },
                appOnForeground: item.appOnForeground,
              }
              dataMarkers.push(body)
            })

            if (this.suggestAddress && !this.suggestDistrict) {
              this.changeCenterProvince()
            } else if (this.suggestAddress && this.suggestDistrict) {
              this.selectDistrict()
            }

            this.markers = dataMarkers
            this.dataMarkerShow = dataMarkers.filter(e => e.userId && e.name && e.mobile)
            this.paginationChange(1)
          } else {
            this.dataItems = []
            this.pagination.totalRows = 0
            this.markers = []
            this.totalTracking = 0
            this.dataMarkerShow = []
          }
        } catch (e) {
          this.error = e.message
        } finally {
          this.loading = false
        }
      },

      transformBeforeSearch() {
        if (this.modelSelectRealTime === 'ON') {
          delete this.search.endTime
          delete this.search.startTime
          this.search.isRealTime = true
        }

        if (this.modelSelectRealTime === 'OFF') {
          this.search.isRealTime = false
          this.search.endTime = moment(this.dateRange.endDate)
            .endOf('day')
            .add(7, 'hours')
            .valueOf()
          this.search.startTime = moment(this.dateRange.startDate)
            .startOf('day')
            .add(7, 'hours')
            .valueOf()
        }

        for (const key in this.search) {
          if (this.search[key] === 'all') delete this.search[key]
        }
      },

      async paginationChange(pageIndex) {
        this.pagination.page = pageIndex
        this.dataItems = []
        const mod = this.pagination.totalRows % this.pagination.size
        if (mod === 0 || (pageIndex - 1) * this.pagination.size < this.pagination.totalRows - mod) {
          for (
            let i = (pageIndex - 1) * this.pagination.size;
            i < pageIndex * this.pagination.size;
            i++
          ) {
            this.dataItems.push(this.dataList[i])
          }
        } else {
          for (let i = this.pagination.totalRows - mod; i < this.pagination.totalRows; i++) {
            this.dataItems.push(this.dataList[i])
          }
        }
      },

      async getSuperiors() {
        try {
          const data = await StaffService.superiors()
          if (data.data.length > 0) {
            const datas = [{ id: 'all', text: 'Tất cả' }]
            data.data.map(e => {
              const body = {
                id: e.userName,
                text: e.name,
              }
              datas.push(body)
            })
            this.dataListManage = datas
          } else {
            this.dataListManage = []
          }
        } catch (error) {
          console.log(error)
          alert('Đã có lỗi xảy ra ! ')
        }
      },

      clickMap(event) {
        this.markers = []
        this.markersCenter.lat = event.latLng.lat()
        this.markersCenter.lng = event.latLng.lng()
      },

      centerChanged(e) {
        const EARTH_RADIUS = 6378137
        const arrayLat = []
        const arrayLng = []

        const lat = e ? e.lat() : (this.markersCenter.lat * Math.PI) / 180.0
        const lon = e ? e.lng() : (this.markersCenter.lng * Math.PI) / 180.0

        for (let index = 0; index < Math.PI * 2; index += 0.3) {
          const latPoint = lat + (this.radiusMap / EARTH_RADIUS) * Math.sin(index)
          const lonPoint = lon + ((this.radiusMap / EARTH_RADIUS) * Math.cos(index)) / Math.cos(lat)
          arrayLat.push((latPoint * 180.0) / Math.PI)
          arrayLng.push((lonPoint * 180.0) / Math.PI)
        }

        this.search.latitudeStart = Math.min(...arrayLat).toString()
        this.search.longitudeStart = Math.min(...arrayLng).toString()
        this.search.latitudeEnd = Math.max(...arrayLat).toString()
        this.search.longitudeEnd = Math.max(...arrayLng).toString()
        this.search.latitudeCenter = this.markersCenter.lat.toString()
        this.search.longitudeCenter = this.markersCenter.lng.toString()
        this.search.radius = this.radiusMap / 1000
      },

      async getStaff() {
        try {
          this.searchStaff.userIdLogin = this.dataUser.userId
          const { data } = await StaffService.getListSelect({ id: this.dataUser.userId })
          this.dataStaffs = data.map(e => ({
            id: e.id,
            text: e.username,
          }))
          this.dataAllStaffs = data
        } catch (e) {
          this.error = e.message
          console.log(e)
        }
      },
      // get data Province
      async suggestLocation() {
        try {
          const params = { adminLocations: this.dataUser.adminLocations }
          const { data } = await TrackingService.getProvince(params)
          const datas = [
            {
              id: '1',
              text: 'Nexttech',
              latitude: this.markersCenter.lat,
              longitude: this.markersCenter.lng,
            },
          ]
          if (data.length > 0) {
            data.map(e => {
              const body = {
                code: e.code,
                id: e.id,
                text: e.prefix + '\t' + e.name,
                latitude: parseFloat(e.latitude),
                longitude: parseFloat(e.longitude),
              }
              datas.push(body)
            })
            this.dataProvince = datas
          } else {
            this.dataProvince = []
          }
        } catch (e) {
          this.error = e.message
          console.log(e)
        } finally {
        }
      },
      // get data District
      async queryDistrict(idProvince) {
        this.dataProvince.forEach(e => {
          if (e.id === idProvince) {
            this.params = { codeCity: e.code }
          }
        })
        try {
          if (idProvince === '1') {
            this.dataDistrict = []
            this.locationCenterSearch = {
              lat: Config.positionNexttech.lat,
              lng: Config.positionNexttech.lng,
            }
            return
          }

          this.changeCenterProvince()

          const datas = []
          const { data } = await TrackingService.getDistrict(this.params)
          if (data.length > 0) {
            data.map(e => {
              const body = {
                code: e.code,
                id: e.id,
                text: e.prefix + '\t' + e.name,
                latitude: parseFloat(e.latitude),
                longitude: parseFloat(e.longitude),
              }
              datas.push(body)
            })
            this.dataDistrict = datas
          } else {
            this.dataDistrict = []
          }
        } catch (e) {
          this.error = e.message
          console.log(e)
        }
      },

      async clickSearch() {
        this.markersCenter = this.locationCenterSearch
        this.transformBeforeSearch()
        this.locationSearch()
      },

      toggleInfo(marker, idx) {
        this.infoWindowPos = marker.position
        this.infoContent = this.getInfoWindowContent(marker)

        if (this.currentMidx === idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },

      getMarkers(key) {
        if (this.selectedKey === key) return this.mapMarkerActive
        return this.mapMarker
      },

      getInfoWindowContent: function (marker) {
        const date = moment(marker.lastUpdated).format('DD/MM/YYYY HH:mm:ss')

        return (
          '' +
          '<div>Tên: <b>' +
          (marker.name ? marker.name : '') +
          '</b></div>' +
          '<div> Điện thoại: <b>' +
          (marker.mobile ? marker.mobile : '') +
          '</b></div>' +
          '<div> Email: <b>' +
          (marker.email ? marker.email : '') +
          '</b></div>' +
          '<div> Thời gian: <b>' +
          // eslint-disable-next-line no-undef
          date +
          '</b></div>'
        )
      },

      getCenterMap(item) {
        const locationChange = this.dataProvince.find(e => e.id === item)
        this.markersCenter = {
          lat: locationChange.latitude,
          lng: locationChange.longitude,
        }
      },

      changeRadius() {
        if (this.radius > 100) {
          alert('Bán kính không được lớn hơn 100km')
          this.radius = 2
        }

        this.radiusMap = parseInt(this.radius) <= 2 ? 2000 : parseInt(this.radius) * 1000
      },

      async clearSearch() {
        this.search = {}
        this.modelSelectRealTime = 'ON'
        delete this.search.endTime
        delete this.search.startTime
        this.search.isRealTime = true

        this.dateRange = {
          startDate: new Date(),
          endDate: new Date(),
        }

        this.radius = 2
        this.radiusMap = parseInt(this.radius) <= 2 ? 2000 : parseInt(this.radius) * 1000
        this.suggestAddress = null
        this.suggestDistrict = null
        this.markersCenter = {
          lat: Config.positionNexttech.lat,
          lng: Config.positionNexttech.lng,
        }
        await this.locationSearch()
      },

      changeCenterProvince() {
        const provinceSelected = this.dataProvince.filter(e => e.id === this.suggestAddress)
        this.locationCenterSearch = {
          lat: provinceSelected[0].latitude,
          lng: provinceSelected[0].longitude,
        }
      },

      selectDistrict() {
        const districtSelected = this.dataDistrict.filter(e => e.id === this.suggestDistrict)
        this.locationCenterSearch = {
          lat: districtSelected[0].latitude,
          lng: districtSelected[0].longitude,
        }
      },

      convertDataStaff(status) {
        const dataUserIds = []
        this.dataAllStaffs
          .filter(e => e.userStatus === status)
          .map(e => {
            dataUserIds.push(e.id)
          })
        this.search.userIds = dataUserIds
      },
    },
  }
</script>

<style scoped>
  .search-staff {
    width: 300px !important;
  }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
